import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';
import { workstationActions } from '@app/store/workstation/actions/workstation.actions';
import { selectWorkstationCode } from '@app/store/workstation/selectors/workstation.selector';
import { unassignedBoxesActions } from '@app/store/unassigned-boxes/actions/unassigned-boxes.actions';
import { placedBoxesActions } from '../actions/placed-boxes.actions';

@Injectable()
export class PlacedBoxesWorkstationBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    clearOnStationChange$ = createEffect(() => {
        return this.actions.pipe(
            ofType(workstationActions.selectWorkstationSuccess, workstationActions.clear),
            map(() => placedBoxesActions.clear()),
        );
    });

    reloadAfterAssign$ = createEffect(() => {
        return this.actions.pipe(
            ofType(unassignedBoxesActions.assignBoxSuccess),
            concatLatestFrom(() => this.store.select(selectWorkstationCode)),
            filter(([, stationCode]) => stationCode !== null),
            map(([, stationCode]) => placedBoxesActions.loadBoxes({ stationCode: stationCode!, page: 1 })),
        );
    });
}
